<template>
    <div>
        <transition name="fade">
            <div class="toast-box show" v-if="show" :class="['bg-'+tipe, 'toast-'+position]" :style="styled">
                <div class="in">
                    <ion-icon name="checkmark-circle" class="text-success" v-if="icon == 'success'"></ion-icon>
                    <ion-icon name="close-circle" class="text-danger" v-else-if="icon == 'danger'"></ion-icon>
                    <ion-icon name="warning" class="text-warning" v-else-if="icon == 'warning'"></ion-icon>
                    <div class="text">{{ message }}</div>
                </div>
                <button type="button" class="btn btn-sm btn-text-light" @click="close" ref="close">OK</button>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'Toast',
    props:{
        show:{
            type: Boolean,
            required: false,
            default: false
        },
        message:{
            type: String,
            required: false,
            default: ''
        },
        tipe:{
            type: String,
            required: false,
            default: 'default'
        },
        styled:{
            type: String,
            required: false,
            default: 'center'
        },
        icon:{
            type: String,
            default: '',
            required: false,
        },
        position:{
            type: String,
            default: 'top',
            required: false,
        }
    },
    data(){
        return{
            toast_time: 3000
        }
    },
    methods:{
        close(){
            this.$emit('close');
            this.$store.commit('RESET_TOAST')
        },
    },
    watch:{
        show(){
            if(this.show){
                setTimeout(() => {
                    this.$emit('update:show', false)
                    this.toast_time = 3000
                }, this.toast_time);
            }
            
        }
    }
        
}
</script>